<style lang="css">
.chainId-dropdown {
  width: 400px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  position: relative;
}

.chainId-dropdown .ivu-input-wrapper {
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
}

.chainId-dropdown .ivu-input {
  border-radius: 0;
}

.pulldown .vxe-pulldown--content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<template>
  <div>
    <vxe-pulldown ref="sellerDown" transfer class="pulldown">
      <template>
        <div :title="row[field]" class="link-text" @click="focusEvent('sellerDown')" target="_black"
             :style="isEdit ? 'cursor: pointer;display: inline-block;width: 100%;text-align: center;color:#2d8cf0;' :'cursor: pointer;display: inline-block;width: 100%;text-align: center;color:#606266;'">
          {{
            row[field] == null ||
            row[field] == "" ? placeholder : row[field]
          }}
        </div>
      </template>
      <template v-slot:dropdown>
        <div class="chainId-dropdown">
          <Input search suffix="ios-search" v-model="name" placeholder @on-search="search" style="width: 200px"/>
          <vxe-grid
              border="none"
              highlight-hover-row
              auto-resize
              height="auto"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              @cell-click="cellClick"
              @page-change="pageChange"
              :pager-config="tablePage"
          ></vxe-grid>
        </div>
      </template>
    </vxe-pulldown>
  </div>
</template>


<script>
import $api from "@/apiProvider";
import {isEmpty} from "@/utils/util";

export default {
  name: "PlatformCorp",
  props: {
    row: {
      type: Object,
      default: null,
    },
    field: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    autoSave: {
      type: Boolean,
      default: true,
    },
    rowIndex: {
      type: Number,
      default: 0
    },
    isFadadaAuth: {
      type: Number,
      default: null
    },
    isDefault: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      tableData: [],
      columns: [{field: "name", title: "企业名称"}], // 选择平台企业下拉框数据列
      name: null, // 承运人订单搜索
      loading: false,
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      },
    };
  },
  methods: {
    pageChange(e) {
      this.tablePage.currentPage = e.currentPage;
      this.tablePage.pageSize = e.pageSize;
      this.getCompanyList();
    },
    focusEvent(name) {
      if (!this.isEdit) return;
      let refs = this.$refs[name];
      refs.showPanel();
      this.name = null;
      this.tablePage = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      };
      this.getCompanyList();
    },
    search() {
      this.tablePage.currentPage = 1;
      this.getCompanyList();
    },
    async getCompanyList() {
      let params = {
        orderBy: 2,
        page: this.tablePage.currentPage,
        rows: this.tablePage.pageSize,
        isFadadaAuth: this.isFadadaAuth,
        isDefault: this.isDefault ? 1 : null,
        state: 1
      };
      if (!isEmpty(this.name)) {
        params.name = this.name;
      }
      if (isEmpty(this.tableData)) {
        this.loading = true;
      }
      let res = await $api.department.get("listCompany", params);
      this.loading = false;
      if (res.status === 1) {
        this.tableData = res.data.rows;
        this.tablePage.total = res.data.total;
      }
    },
    cellClick({row}) {
      if (this.autoSave) {
        this.$set(this.row, this.field, row.name);
        this.$set(this.row, this.field + "Id", row.id);
        this.row.platformCompanyId = row.id;
      } else {
        this.$emit("update", row, row.id, row.name);
      }
      if (this.rowIndex !== null) {
        this.row.index = this.rowIndex;
      }
      let index = this.row;
      this.$refs.sellerDown.hidePanel();
      this.$emit("select", true, index, row);
    },
  },
};
</script>